export class S1ClientInfo {
    clientName : string;
    clientVersion:string;
}